import store from '@/app/store/store';
import getParameterByName from '@/app/utils/getParameterByName';
import { recordPagesLastAction } from '@/utils/pagesBannerAction';

let registered = false;

// Mirror the V7 editor: on a successful save/publish, share the action with the Shopify app's Pages
// banner via a cross-subdomain cookie. Hooks the legacy store flags the gryff editor flips on success
// (__isSaved / __isPublished set to true). A publish also flips __isSaved, so the SAVED write is
// guarded by __isPublished to make PUBLISHED win regardless of callback order.
export const useRecordPagesBannerAction = () => {
  onMounted(() => {
    if (registered) return;
    registered = true;

    const shopDomain = getParameterByName('shop');

    store.onChange('__isSaved', (value: boolean) => {
      if (value && !store.getValue('__isPublished')) recordPagesLastAction(shopDomain, 'SAVED');
    });

    store.onChange('__isPublished', (value: boolean) => {
      if (value) recordPagesLastAction(shopDomain, 'PUBLISHED');
    });
  });
};
